import { Instagram, ArrowUpRight } from "lucide-react";
import { TEST_IDS } from "@/lib/testIds";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "@/lib/contact";
import { Logo } from "./Logo";

const navLinks = [
  { id: "anasayfa", label: "Anasayfa", slug: "home" },
  { id: "hakkimda", label: "Hakkımda", slug: "about" },
  { id: "hizmetler", label: "Hizmetler", slug: "services" },
  { id: "iletisim", label: "İletişim", slug: "contact" },
];

const scrollTo = (e, id) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  return (
    <footer className="relative bg-[#0A1628] text-white border-t border-white/10 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#10B981] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo variant="full" size={40} white />
            <p className="mt-6 text-sm text-white/65 max-w-sm leading-relaxed">
              Klinik disiplinin sporcu performansına dönüştüğü, kanıta dayalı
              beslenme protokolleri.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="label-eyebrow mb-4 text-[#10B981]">Hızlı Bağlantılar</p>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-6">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => scrollTo(e, l.id)}
                    data-testid={TEST_IDS.footer.navLink(l.slug)}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-white/80 hover:text-[#10B981] transition-colors group"
                  >
                    {l.label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label-eyebrow mb-4 text-[#10B981]">Takip Et</p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={TEST_IDS.footer.instagram}
              className="inline-flex items-center gap-3 px-4 py-3 rounded-full bg-white/5 border border-white/10 text-sm font-semibold text-white hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#0EA5E9] hover:border-transparent transition-all duration-300"
            >
              <Instagram className="w-4 h-4" />
              {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
            © 2026 Berke Akdağ. Tüm hakları saklıdır.
          </p>
          <p className="text-[11px] uppercase tracking-[0.22em] text-white/40">
            diyetisyenberkeakdag.com
          </p>
        </div>
      </div>

      {/* Bottom wordmark band */}
      <div className="relative overflow-hidden border-t border-white/10">
        <p className="font-heading font-black text-[18vw] md:text-[14vw] leading-none whitespace-nowrap text-center select-none py-6 bg-gradient-to-r from-white/5 via-[#10B981]/15 to-white/5 bg-clip-text text-transparent">
          BERKE · AKDAĞ
        </p>
      </div>
    </footer>
  );
};

export default Footer;
